(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8006],{

/***/ 21173:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reset-password",
      function () {
        return __webpack_require__(64267);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_reset_password; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/index.ts + 138 modules
var components = __webpack_require__(36357);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(66688);
// EXTERNAL MODULE: ./node_modules/@apollo/react-hooks/lib/react-hooks.esm.js
var react_hooks_esm = __webpack_require__(18499);
// EXTERNAL MODULE: ./node_modules/toggled/dist/toggled.esm.js
var toggled_esm = __webpack_require__(67866);
// EXTERNAL MODULE: ./src/gql/mutations/index.ts + 42 modules
var mutations = __webpack_require__(36651);
// EXTERNAL MODULE: ./src/layouts/index.ts + 17 modules
var layouts = __webpack_require__(63409);
// EXTERNAL MODULE: ./src/utils/index.ts + 24 modules
var utils = __webpack_require__(90644);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(13135);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/truck/field/index.tsx + 2 modules
var field = __webpack_require__(49318);
// EXTERNAL MODULE: ./src/truck/new-button/NewButton.tsx + 4 modules
var NewButton = __webpack_require__(8262);
;// CONCATENATED MODULE: ./src/screens/reset-password/ResetPasswordForm.tsx






function ResetPasswordForm(param) {
    var handleSubmit = param.handleSubmit, submitting = param.submitting, submitSucceeded = param.submitSucceeded, className = param.className;
    if (submitSucceeded) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx/* default */.Z)("flex flex-col gap-4", className),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Te hemos enviado un correo con instrucciones para cambiar tu contrase\xf1a. Si este no aparece dentro de unos minutos, revisa tu spam."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/ingresar",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewButton/* default */.Z, {
                        children: "Regresar a iniciar sesi\xf3n"
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        className: (0,clsx/* default */.Z)("flex flex-col gap-4"),
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(field/* default */.Z, {
                name: "email",
                placeholder: "Correo electr\xf3nico"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewButton/* default */.Z, {
                loading: submitting,
                type: "submit",
                children: "Recuperar Contrase\xf1a"
            })
        ]
    });
}
/* harmony default export */ var reset_password_ResetPasswordForm = (ResetPasswordForm);

;// CONCATENATED MODULE: ./src/screens/reset-password/index.tsx













function ResetPasswordScreen() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,react_hooks_esm/* useMutation */.Db)(mutations/* resetPasswordMutation */.g4), 1), resetPassword = ref[0];
    var hasLoginRequiredFF = (0,toggled_esm/* useFlag */.P5)(constants/* flags.LOGIN_REQUIRED */.id.LOGIN_REQUIRED);
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            resetPassword({
                                variables: values
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        return [
                            2,
                            (0,utils/* handleSubmissionErrors */.ou)(error)
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
        onSubmit: onSubmit,
        validate: utils/* formValidators.resetPassword */.BQ.resetPassword,
        children: function(formProps) {
            if (hasLoginRequiredFF) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts/* PrivateAuthLayout */.Uz, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "text-center text-xl font-semibold",
                                children: "Recuperar Contrase\xf1a"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(reset_password_ResetPasswordForm, {
                                handleSubmit: formProps.handleSubmit,
                                submitting: formProps.submitting,
                                submitSucceeded: formProps.submitSucceeded
                            })
                        ]
                    })
                });
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts/* DefaultLayout */.HQ, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mx-auto flex w-full flex-col gap-4 lg:w-1/2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            className: "text-center text-xl font-semibold",
                            children: "Recuperar Contrase\xf1a"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(reset_password_ResetPasswordForm, {
                            handleSubmit: formProps.handleSubmit,
                            submitting: formProps.submitting,
                            submitSucceeded: formProps.submitSucceeded
                        })
                    ]
                })
            });
        }
    });
}
/* harmony default export */ var reset_password = (ResetPasswordScreen);

;// CONCATENATED MODULE: ./pages/reset-password.tsx







function ResetPasswordPage(props) {
    var metaInfo = props.metaInfo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Meta */.h_, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, metaInfo), {
                title: "Recuperar contrase\xf1a",
                noRobots: true
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(reset_password, {})
        ]
    });
}
ResetPasswordPage.getInitialProps = function(context) {
    return {
        metaInfo: (0,utils/* getMetaInfo */.R7)(context)
    };
};
/* harmony default export */ var pages_reset_password = (ResetPasswordPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [157,3409,9774,2888,179], function() { return __webpack_exec__(49484), __webpack_exec__(21173); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);